var requirejs = {
    baseUrl: '/public/include/js',
    defaultErrback: null,
    paths: {
        apmui: 'modern',
        customization: '/customization',
    },
    map: {
        '*': {
            react: 'preact/compat',
            'react-dom': 'preact/compat',
        },
    },
};
